import styled from '@emotion/styled';
import { Form, Row } from 'antd';

export const RootFormContainer = styled(Form)`
  height: 100vh;
  min-width: 768px;
  overflow-x: scroll;
`;

export const WizardNavHeader = styled.div`
  width: 78%;
  margin: 0 auto;
`;

export const NavButtonsContainer = styled(Row)`
  margin: 80px 0 ${props => props.theme.spacing.md} 0;
`;

export const StepTitle = styled.span`
  color: ${props => props.isActive && props.theme.color.primary};
  font-weight: ${props => props.theme.color.bold};
`;

export const ContentContainer = styled(Row)`
  padding: ${props => props.theme.spacing.md} ${props => (props.shouldShowTips ? 0 : '11%')} ${props => props.theme.spacing.md} 11%;
`;
